import {
    TabComponent,
    TabItemDirective,
    TabItemsDirective,
  } from '@syncfusion/ej2-react-navigations';
  import * as React from 'react';
import OrderRequest from './OrderRequest';
  interface IProps {}
  interface IState {
  }
  class CloudDiscoveryTab extends React.Component<IProps, IState> {
    private headerText: any;
    constructor(props: IProps) {
      super(props);
      this.state = {
        currentTab: 0,
      };
      this.headerText = [
        { text: 'Request Management' },
        { text: 'Request Summary' },
        { text: 'Mobile App Requests' },
      ];
    }
    content0() {
      return (
        <div>
          <div className='row mt-3 p-2'>
            <div className='col-md-12'>
              <OrderRequest first_load_request={true}/>
            </div>
          </div>
        </div>
      );
    }
   
    begin(args:any){
      if(args.isSwiped){
        args.cancel=true
      }
    }
    render() {
      return (
        <TabComponent
          heightAdjustMode='Auto'
          selecting={this.begin.bind(this)}
          enablePersistence
          statelessTemplates={['directiveTemplates']}
        >
          <TabItemsDirective>
            <TabItemDirective
              header={this.headerText[0]}
              content={this.content0}
            />
            {/* <TabItemDirective
              header={this.headerText[1]}
              content={this.content1}
            /> */}
            {/* <TabItemDirective
              header={this.headerText[2]}
              content={this.content2}
            />
            <TabItemDirective
              header={{ text: 'Mobile App Requests Field' }}
              content={this.contentRequestField}
            /> */}
          </TabItemsDirective>
        </TabComponent>
      );
    }
  }
  export default CloudDiscoveryTab;
  